import script from "./XCalendar.vue?vue&type=script&lang=ts&setup=true"
export * from "./XCalendar.vue?vue&type=script&lang=ts&setup=true"

import "./XCalendar.vue?vue&type=style&index=0&id=7ec7f650&lang=css&scoped=true"

import exportComponent from "/Users/nicholas/Documents/Work/Workspace/x1/hotelOS/vue3-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec7f650"]])

export default __exports__